<div class="recap-catalogue-import container">
  <div class="recap-header">
    <div>
      <p class="eyebrow">Import catalogo</p>
      <h1>Conferma importazione</h1>
      <p class="lead">Controlla i film rilevati, seleziona quelli da importare o aggiornare e conferma l'operazione.</p>
      <p class="migration-id">Migration ID: {{ migrationId }}</p>
    </div>

    <div class="recap-side">
      <p-button label="Nuovo import"
                icon="pi pi-upload"
                variant="outlined"
                (click)="goToImport()"></p-button>

    </div>
  </div>

  @if (loading) {
    <div class="status">Caricamento recap...</div>
  } @else if (errorMessage) {
    <div class="status error">{{ errorMessage }}</div>
  } @else if (commitResponse) {
    <section class="import-success">
      <img src="assets/layout/images/catalogue-import-success.png"
           alt="Importazione completata">

      <div class="import-success-copy">
        <p class="eyebrow">Import completato</p>
        <h2>Catalogo aggiornato correttamente</h2>
        <p>Sono stati importati {{ commitResponse.imported }} nuovi film e aggiornati {{ commitResponse.updated }} film.</p>

        <div class="success-actions">
          <p-button label="Nuovo import"
                    icon="pi pi-upload"
                    (click)="goToImport()"></p-button>
          <p-button label="Torna al catalogo"
                    icon="pi pi-list"
                    variant="outlined"
                    (click)="goToCatalogue()"></p-button>
        </div>
      </div>
    </section>
  } @else if (migration) {
    <section class="summary">
      <div>
        <span>Righe totali</span>
        <strong>{{ migration.totalRows }}</strong>
      </div>
      <div>
        <span>Nuovi film</span>
        <strong>{{ newMoviesCount }}</strong>
      </div>
      <div>
        <span>Tassonomie mancanti</span>
        <strong>{{ missingGenres.length + missingSubGenres.length }}</strong>
      </div>
    </section>

    @if (mustResolveTaxonomies) {
      <section class="missing-taxonomies">
        <div class="missing-taxonomies-header">
          <h2>Traduzioni mancanti</h2>
          <p>Inserisci il titolo inglese per continuare l'importazione.</p>
        </div>

        <div class="taxonomy-form">
          <div class="taxonomy-row taxonomy-row-header">
            <span>Tipo</span>
            <span>Nome</span>
            <span>Traduzione inglese</span>
          </div>
          @for (item of missingTaxonomyTranslations; track item.name + (item.isSubGenre ? '-sub' : '-genre')) {
            <div class="taxonomy-row">
              <span>{{ item.isSubGenre ? 'Sottogenere' : 'Genere' }}</span>
              <strong>{{ item.name }}</strong>
              <input pInputText
                     type="text"
                     placeholder="Traduzione inglese"
                     [(ngModel)]="item.englishName">
            </div>
          }
        </div>

        <div class="taxonomy-actions">
          <p-button label="Salva e continua"
                    icon="pi pi-save"
                    [loading]="savingTaxonomies"
                    [disabled]="!areTaxonomyTranslationsValid || savingTaxonomies"
                    (click)="saveMissingTaxonomies()"></p-button>
        </div>
      </section>
    } @else {
      <section class="selection-toolbar">
        <div class="search-box">
          <i class="pi pi-search"></i>
          <input pInputText
                 type="search"
                 placeholder="Cerca film, regia, genere o sottogenere"
                 [(ngModel)]="searchText">
        </div>

        <div class="selection-actions">
          <span>{{ selectedCount }} film selezionati</span>
          <p-button label="Seleziona filtrati"
                    icon="pi pi-check-square"
                    variant="outlined"
                    size="small"
                    (click)="selectFiltered()"></p-button>
          <p-button label="Deseleziona filtrati"
                    icon="pi pi-minus-circle"
                    variant="outlined"
                    severity="secondary"
                    size="small"
                    (click)="deselectFiltered()"></p-button>
          <p-button label="Conferma importazione"
                    icon="pi pi-check"
                    size="small"
                    [loading]="committing"
                    [disabled]="selectedCount === 0 || committing"
                    (click)="confirmImport()"></p-button>
        </div>
      </section>

      <p-table [value]="filteredEntries"
               [(selection)]="selectedEntries"
               dataKey="rowNumber"
               selectionMode="multiple"
               [metaKeySelection]="false"
               styleClass="p-datatable p-datatable-striped p-datatable-sm p-datatable-gridlines"
               [paginator]="false"
               [rowHover]="true"
               responsiveLayout="scroll">
        <ng-template pTemplate="header">
          <tr>
            <th class="selection-column">
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            <th>Film</th>
            <th>Regia</th>
            <th>Genere</th>
            <th>Sottogenere</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row"
              [class.new-movie-row]="!row.movie.key">
            <td class="selection-column">
              <p-tableCheckbox [value]="row"></p-tableCheckbox>
            </td>
            <td>
              <div class="movie-cell">
                @if (!row.movie.key) {
                  <span class="new-row-badge"
                        title="Nuovo film">
                    <i class="pi pi-plus-circle"
                       aria-hidden="true"></i>
                    <span>Nuovo</span>
                  </span>
                }
                <span>{{ obj(row).movie.title || '-' }}, {{ row.movie.year || '-' }}</span>
              </div>
            </td>
            <td>{{ obj(row).movie.direction || '-' }}</td>
            <td>{{ obj(row).genreName || '-' }}</td>
            <td>{{ obj(row).subGenreName || '-' }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="5">Nessuna riga trovata.</td>
          </tr>
        </ng-template>
      </p-table>
    }
  }
</div>
